import * as yup from "yup";
import { createRequiredTrimmedString, createRichTextRequiredSchema } from "./schemaUtils";

export const createMilestone = yup
  .object({
    epic_name: createRequiredTrimmedString("Name is required").max(
      30,
      "Maximum 30 characters allowed"
    ),
    description: createRichTextRequiredSchema(
      "Description is required",
      "Description cannot be empty"
    ),
    start_date: yup
      .date()
      .nullable()
      .max(
        yup.ref("target_release_date"),
        "Start date can't be after target date"
      ),
    target_release_date: yup
      .date()
      .nullable()
      .min(yup.ref("start_date"), "End date can't be before start date"),
  })
  .required();
